<template>
    <div>
        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="appbar-icon-button-small btn-bg-color-blue"
                    :class="{
                        'red-color': product.comment,
                        'dark-blue-color': !product.comment,
                    }"
                    @click="openCommentDialog"
                    v-on="on"
                    v-bind="attrs"
                >
                    mdi-message-reply-text-outline
                </v-icon>
            </template>
            <span>{{ $t('comment.edit') }}</span>
        </v-tooltip>

        <app-dialog :value="isCommentDialogOpen" @input="isCommentDialogOpen = $event" :title="$t('comment.title')" width="760px">
            <template v-slot:content>
                <v-row class="d-flex flex-column">
                    <v-col cols="12">
                        <v-form ref="form" lazy-validation>
                            <v-textarea autofocus :label="$t('comment.placeholder')" v-model.trim="form.comment" :rules="[rules.message_length]" dense no-resize rows="5"></v-textarea>
                        </v-form>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:buttons>
                <v-btn text outlined class="myprovet-btn-cancel px-8" @click="cancelComment"> {{ $t('common.cancel') }} </v-btn>

                <v-btn text v-if="form.comment" outlined class="myprovet-btn-cancel px-8" @click="clearComment"> {{ $t('table.clear') }} </v-btn>

                <v-btn text class="myprovet-btn-ok px-8" @click="saveComment"> {{ $t('comment.save') }} </v-btn>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
export default {
    props: {
        productObj: Object,
        pendingProductsComments: Array,
    },

    data: () => ({
        product: null,
        isCommentDialogOpen: false,

        form: {
            comment: null,
            errors: null,
        },

        rules: {
            message_length: (value) => !value || (value && value.length <= 255) || i18n.t('comment.maxLength'),
        },
    }),

    watch: {
        productObj: {
            handler: function () {
                this.product = this.productObj;
                this.product.comment = this.getProductComment(this.product);
            },
            immediate: true,
        },
    },

    methods: {
        getProductComment(product) {
            const item = this.pendingProductsComments.find((item) => item.id === product.id);
            return item !== undefined ? item.comment : null;
        },

        openCommentDialog() {
            this.form.comment = this.product?.comment;
            this.isCommentDialogOpen = true;
        },

        saveComment() {
            if (!this.$refs.form.validate()) return;

            this.product.comment = this.form.comment;
            window.EventBus.$emit('on-save-pending-product-comment', this.product);

            this.cancelComment();
        },

        clearComment() {
            this.form.comment = null;
        },

        cancelComment() {
            this.isCommentDialogOpen = false;
            this.form.comment = null;
        },
    },
};
</script>
